import { Card, Grid, Typography } from '@mui/material';
import React from 'react';

import { useStyles } from './styles';

interface MyProps {
  fullName?: string;
  documentNumber?: string;
  classes?: any;
  documentType?: string;
  address?: string;
  phone?: string;
  email?: string;
}

const CardUserComponent: React.FC<MyProps> = (data: MyProps) => {
  const { classes } = data;
  const local = useStyles();

  const fields = [
    { label: 'Tipo de documento:', value: data.documentType },
    { label: 'No. de identificación:', value: data.documentNumber },
    { label: 'Dirección:', value: data.address },
    { label: 'Teléfono:', value: data.phone },
    { label: 'Correo electrónico:', value: data.email },
  ];

  return (
    <Grid lg={12} md={12} xs={12}>
      <Card className={`${classes.containerDetail} ${classes.containerDataUser}`}>
        <Typography variant="h6" className={classes.titlePersonName}>
          {data.fullName}
        </Typography>
        <div className={local.dataGrid}>
          {fields.map((f) => (
            <React.Fragment key={f.label}>
              <Typography className={local.lbl}>{f.label}</Typography>
              <Typography className={local.val}>{f.value ? f.value : '-'}</Typography>
            </React.Fragment>
          ))}
        </div>
      </Card>
    </Grid>
  );
};

export default CardUserComponent;
